import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { JsxEmit } from 'typescript';
import { formatCurrency } from '../../../../utils';

type AmountTobePaidProps = {
  fn?: () => void;
  amountToBePaid: string;
  userCurrency: any
};

const AmountTobePaid: React.FC<AmountTobePaidProps> = ({
  fn,
  amountToBePaid,
  children,
  userCurrency,
}): JSX.Element => {
  return (
    <div onClick={() => fn && fn()} className="amount-to-be-paid">
      <div className="text">
        <p>Amount to be paid</p>
        <p>
          {formatCurrency(
            amountToBePaid,
            userCurrency.ratio,
            userCurrency.currency,
          )}
        </p>
      </div>
      {children}
    </div>
  );
};

export default AmountTobePaid;
